module.exports = __webpack_public_path__ + "static/media/02.8ee339c1.JPG";